import { gql } from '@apollo/client';

export const GET_TASK_DELEGATIONS_COUNT = gql`
  query GET_TASK_DELEGATIONS_COUNT($query: TaskDelegationsQueryModelInput) {
    taskDelegations(query: $query) {
      totalCount
    }
  }
`;

export const GET_TASK_DELEGATIONS = gql`
  query GET_TASK_DELEGATIONS(
    $query: TaskDelegationsQueryModelInput
    $sort: [TaskDelegationSortModelInput]
    $page: PageModelInput
  ) {
    taskDelegations(query: $query, sort: $sort, page: $page) {
      totalCount
      items {
        originalAssignee {
          fullName
          profilePhoto {
            uid
            signedUrl
          }
          uid
          status
        }
        delegateAssignee {
          fullName
          profilePhoto {
            uid
            signedUrl
          }
          uid
          status
        }
        processDefinitions {
          name
          uid
        }
        task {
          name
          uid
        }
        status
        startDate
        endDate
        creator {
          fullName
          profilePhoto {
            uid
            signedUrl
          }
          uid
          status
        }
        uid
      }
    }
  }
`;
